import { Component, Injectable, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatError, MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { EcaFormColumnModule, EcaMultiSelectModule, EcaPaginatorModule } from '@drc-eca/eca-components-lib';
import { MatInput } from '@angular/material/input';

@Component({
    selector: 'app-update-outage-modal',
    standalone: true,
    templateUrl: './update-outage-modal.component.html',
    styleUrls: ['./update-outage-modal.component.scss'],
    imports: [ 
      MatButton, 
      MatFormField,
      MatSelect,
      MatOption,
      MatLabel,
      MatIcon,
      MatLabel,
      MatFormField,
      MatIcon,
      MatInput,
      FormsModule,
      MatDialogModule,
      EcaMultiSelectModule,
      EcaFormColumnModule,
      EcaPaginatorModule,
      MatError,
      MatFormFieldModule,
      ReactiveFormsModule
    ]
})
@Injectable({ providedIn: 'root' })
export class UpdateOutageModalComponent {
  dialogRef = inject<MatDialogRef<UpdateOutageModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  form: UntypedFormGroup = new UntypedFormGroup({
    title: new UntypedFormControl(null, Validators.required),
    comment: new UntypedFormControl(null, Validators.required),
    status: new UntypedFormControl(null, Validators.required),
    severity: new UntypedFormControl(null, Validators.required),
    services: new UntypedFormControl([], Validators.required),
    clients: new UntypedFormControl([], Validators.required),
  });
  serviceSeverityList: string[] = [];
  serviceStatusList: string[] = [];
  clientList: string[] = [];
  serviceList: { label: string, value: string }[] = [];

  constructor() {
    const data = this.data;

    const outage = data.outage || {};
    ['title', 'status', 'severity', 'services', 'clients'].forEach(key =>{
      this.form.controls[key].setValue(outage[key]);
    });
    this.clientList = (data.clientList || []).map((cl: any) => cl.code);
    this.serviceList = (data.serviceList || []).map((sl: any) => {
      return {
        label: sl.name,
        value: sl.primaryKeyPart
      };
    });
    this.serviceStatusList = data.serviceStatusList;
    this.serviceSeverityList = data.serviceSeverityList;
  }

  checkcommentRequired(){
    if(this.form.controls.status.value == 'Resolved'){
      if(!this.form.controls.comment.value){
        this.form.controls.comment.setValue('Resolved.');
        this.form.controls.comment.updateValueAndValidity();
      }
      
    }
  }

}
